import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

function Laverage(props) {
    return (
        <div className="laverage_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>TekRevol's Proven Steps to Web Design and Development Success</h2>
                        <p>At TekRevol, we follow a clear and effective process to ensure the success of your web design and development project. Our method includes the following key steps:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                    <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Discovery</h6>
                                <p>Conducting Product Discovery and Product Research</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Design</h6>
                                <p>Our skilled designers bring ideas to life with visually stunning, user-friendly design</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Develop</h6>
                                <p>We employ cutting-edge tech and code for a responsive, feature-rich website.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Test and Launch</h6>
                                <p>Rigorous testing guarantees flawless functionality, performance, and security for successful launch</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Support and Enhancement</h6>
                                <p>We offer continuous support for updates and enhancements, ensuring your web presence stays effective.</p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;